import { IActionLinkItem } from "Models/actionItem";

export interface ICommand {
    executeAsync(obj: any): Promise<boolean>;
}

export interface IFactoryCommand {
    getCommand(name: string): ICommand;
}

export default class Context {
    private _factory: IFactoryCommand;

    constructor(factory: IFactoryCommand) {
        this._factory = factory;
    }
    
    executeAsync(commandName: string, obj: any): Promise<boolean> | null {
        return new Promise(async (resolve, reject) => {
            const _command = this._factory.getCommand(commandName);
            if (!!_command) {
               const result = await _command.executeAsync(obj);
               resolve(result);
               return;
            }
            reject();
        });
    }
}

export class defaultCommand implements ICommand {
    executeAsync(obj: any): Promise<boolean> {
        throw new Error("the method is not implemented.");
    }
}

export class navigateCommand implements ICommand {
    private _vm: any;
    constructor(vm: any) {
        this._vm = vm;
    }

    executeAsync(obj: any): Promise<boolean> {
        return new Promise(resolve => {
            const actionLink = obj as IActionLinkItem;
            if (!!actionLink.routeLink) {
                this._vm.$router.push({ name: actionLink.routeLink.name });
            } else {
                this._vm.notify.error({
                    description: `Đường dẫn "${actionLink.text}" không tồn tại`
                });
            }
            resolve(true);
        })
    }
}
